import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a18ed3ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm py-0 px-1 border-0 note-btn" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "note" }, " ? ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_popover_ui = _resolveComponent("popover-ui")!

  return (_openBlock(), _createBlock(_component_popover_ui, {
    class: "border-0 m-0",
    content: _ctx.note
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["content"]))
}